import type React from "react";
import { Link } from "react-router-dom";
import type { Game } from "../../types";
import style from "./GameCard.module.scss";

type Props = {
	game: Game;
};
export const GameCard: React.FC<Props> = ({ game }) => {
	return (
		<Link to={`/games/${game.type}`}>
			<div className={style.gameCard}>
				<img className={style.gameCard__image} alt="game" src={game.image} />
				<div className={style.gameCard__content}>
					<p className={style.gameCard__title}>{game.name}</p>
				</div>
			</div>
		</Link>
	);
};
